import pkg from "../package.json";

/**
 * Extracts and formats semantic version string from raw tag/env or fallback.
 * Examples:
 * - "miniapp-v0.1.4" -> "0.1.4"
 * - "v1.2.0" -> "1.2.0"
 * - "0.1.4" -> "0.1.4"
 * - "miniapp-v0.1.4-beta.1" -> "0.1.4-beta.1"
 * - undefined / empty -> package.json version or "0.1.0"
 */
export function parseAppVersion(raw?: string): string {
  if (!raw || typeof raw !== "string" || raw.trim().length === 0) {
    return (pkg.version && pkg.version.trim()) || "0.1.0";
  }
  const trimmed = raw.trim();
  const withoutPrefix = trimmed.replace(/^miniapp-v?|^v/, "");
  return withoutPrefix || (pkg.version && pkg.version.trim()) || "0.1.0";
}

export const APP_VERSION = parseAppVersion(import.meta.env.VITE_APP_VERSION);
